module.exports = __webpack_public_path__ + "media/3.6e23a67e.mp3";